import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import { LanguageProvider } from './context/LanguageContext';
import App from './App';
import './index.css';

// #943 — Console-Error Capture für Bug-Report-Auto-Kontext (Ring-Buffer 50)
if (typeof window !== 'undefined' && !window.__weshipConsoleErrors) {
  window.__weshipConsoleErrors = [];
  const origError = console.error.bind(console);
  console.error = (...args) => {
    try {
      const line = args.map((a) => {
        if (a instanceof Error) return `${a.name}: ${a.message}`;
        if (typeof a === 'object') { try { return JSON.stringify(a); } catch { return String(a); } }
        return String(a);
      }).join(' ');
      window.__weshipConsoleErrors.push(`[${new Date().toISOString()}] ${line}`.slice(0, 500));
      if (window.__weshipConsoleErrors.length > 50) window.__weshipConsoleErrors.shift();
    } catch {}
    origError(...args);
  };
  window.addEventListener('error', (e) => {
    try {
      window.__weshipConsoleErrors.push(`[${new Date().toISOString()}] window.error: ${e.message} @ ${e.filename}:${e.lineno}`.slice(0, 500));
      if (window.__weshipConsoleErrors.length > 50) window.__weshipConsoleErrors.shift();
    } catch {}
  });
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider>
        <LanguageProvider>
          <App />
        </LanguageProvider>
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>
);
